import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  bigIcon: {
    fontSize: '4em',
  },
  midIcon: {
    fontSize: '3em'
  },
  clockIcon: {
    fontSize: '3em',
  },
  timerWrapper:{
    marginRight: '5px',
  },
  colorIcon:{
    color: '#658D1B'
  },
  disabledIcon: {
    color: '#D9D9D6'
  },
  info: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '10px'
  },
  infoItem:{
    flexGrow: '1'
  },
  infoLeftSpace:{
    marginLeft: '50px',
  },
  infoBorder:{
    borderColor: '#999999',
    borderRightStyle: 'solid',
    borderRightWidth: '1px',
    opacity: '0.4'
  },
  itemRow:{
    display: 'flex',
    flexDirection: 'row'
  },
  phoneElement: {
    display: 'flex',
    flexDirection: 'row'
  },
  allPhones: {
    display: 'flex',
    flexDirection: 'column'
  },
  actionVCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px'
  },
  infoDriver: {
    display: 'flex',
    alignItems: 'center',
    color: '#B2B2B2',
    justifyContent: 'end'
  },
  infoDriverLeft: {
    display: 'flex',
    alignItems: 'flex-start',
    color: '#B2B2B2',
    justifyContent: 'start'
  },
  smallIcon:{
    width: '28px',
  },
  infoDriverLabel:{
    width: '80px'
  },
  infoValue:{
    fontSize: '1.4em',
    fontWeight: 700,
    color: '#4C4C4C',
    minWidth: '140px'
  },
  inputPhone:{
    border: 'none',
    height: '28px',
    backgroundColor: '#D9D9D6',
    fontSize: '1em',
    fontWeight: 600,
    color: '#4C4C4C',
    maxWidth: '140px'
  },
  noButtonStyle:{
    background: 'none',
    color: 'inherit',
    border: 'none',
    padding: 0,
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
  },
  alignRight:{
    justifyContent: 'flex-end'
  },
  note:{
    color: '#666666',
    fontWeight: 700,
    fontSize: `0.8em`,
    height: '48px',
    width: '148px',
  },
  textGray30:{
    color: '#B2B2B2'
  },
  containerButtonStyle:{
    display: 'flex'
  },
  colorDangerIcon:{
    color: '#D63C43'
  }
}));

export default useStyles;
